import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchCreateTestimonialThunk, fetchtestimonialListingThunk } from './testimonialApi'

const initialState = {
	CreateTestimonialData: [],
	TestimonialData: [],
	totalCountOfTestimonialData: [],
}

export const getCreateTestimonialData = createAsyncThunk('user/getCreateTestimonialData', fetchCreateTestimonialThunk)
export const getTestimonialData = createAsyncThunk('user/getTestimonialData', fetchtestimonialListingThunk)

export const testimonialSlice = createSlice({
	name: 'testimonial',
	initialState,
	reducers: {
		// setUserProfileData: (state, action) => {
		// 	state.profileData = action.payload
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(getCreateTestimonialData.fulfilled, (state, action) => {
			state.CreateTestimonialData = action.payload?.data
		})
		builder.addCase(getTestimonialData.fulfilled, (state, action) => {
			state.TestimonialData = action.payload?.data
			state.totalCountOfTestimonialData = action.payload?.total
		})
	},
})
export default testimonialSlice.reducer
